import React from 'react';

// components
import {CardBorder} from '../../../shared/components';

// styles
import {CardContactWrapper, IconEmail} from '../ContactPage-styles';
import {LinkPrimary} from '../../../shared/styles';

// types
type Props = {
  supportEmail: string | undefined;
};

const CardEmailContact = ({supportEmail}: Props) => {
  /**
   * When the card is clicked, it redirects to the email client
   */
  const onCardClick = () => {
    if (supportEmail) {
      return (window.location.href = `mailto:${supportEmail}`);
    }
  };

  return (
    <CardBorder variant="primary">
      <CardContactWrapper
        onClick={onCardClick}
        isHoverable={supportEmail != null}>
        <IconEmail />
        {supportEmail ? <LinkPrimary>{supportEmail}</LinkPrimary> : '-'}
      </CardContactWrapper>
    </CardBorder>
  );
};

export default CardEmailContact;
